var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
/** @overridable */
import { XList } from "@bluelibs/x-ui-admin";
import { Routes } from "@bundles/UIAppBundle";
import * as Ant from "antd";
import { Service } from "@bluelibs/core";
import { TransactionType, UserRole } from "@root/api.types";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Transactions } from "@bundles/UIAppBundle/icons/transactions";
import TransactionApprovalButton from "@bundles/UIAppBundle/components/TransactionApprovalButton/TransactionApprovalButton";
const YELLOW = "#FFA70E";
const RED = "#B03A2E";
const GREEN = "#6CDA6A";
const GRAY = "#909090";
let PaymentToApproveTransactionList = class PaymentToApproveTransactionList extends XList {
    constructor() {
        super(...arguments);
        this.roles = [];
    }
    setRoles(roles) {
        this.roles = roles;
    }
    build() {
        const { UIComponents, router } = this;
        const { t } = this.i18n;
        const isAdmin = this.roles.find((role) => [UserRole.ADMIN, UserRole.SHAREHOLDER].includes(role))
            ? true
            : false;
        const isShareholder = this.roles.find((role) => [UserRole.SHAREHOLDER].includes(role))
            ? true
            : false;
        this.add([
            {
                id: "type",
                title: t("management.transactions.fields.type"),
                key: "management.transactions.fields.type",
                dataIndex: ["type"],
                sorter: true,
                width: 100,
                render: (value) => {
                    let i18nValue = "";
                    switch (value) {
                        case TransactionType.expense:
                            i18nValue = t("management.transactions.list.type.expense");
                            return (_jsx(Ant.Tooltip, Object.assign({ title: i18nValue }, { children: _jsx(UploadOutlined, { style: { color: RED, fontSize: 20 } }, void 0) }), void 0));
                        case TransactionType.income:
                            i18nValue = t("management.transactions.list.type.income");
                            return (_jsx(Ant.Tooltip, Object.assign({ title: i18nValue }, { children: _jsx(DownloadOutlined, { style: { color: GREEN, fontSize: 20 } }, void 0) }), void 0));
                        case TransactionType.internal:
                            i18nValue = t("management.transactions.list.type.internal");
                            return (_jsx(Ant.Tooltip, Object.assign({ title: i18nValue }, { children: _jsx(Transactions, { style: { width: 20, height: 20, color: GRAY } }, void 0) }), void 0));
                    }
                    const props = {
                        type: "string",
                        value: i18nValue,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "external",
                title: t("management.transactions.fields.external"),
                key: "management.transactions.fields.external",
                dataIndex: ["external"],
                sorter: true,
                width: 275,
                render: (value, model) => {
                    const props = {
                        type: "relation",
                        value,
                        relation: {
                            path: router.path(Routes.EXTERNALS_VIEW, {
                                params: {
                                    id: value === null || value === void 0 ? void 0 : value._id,
                                },
                            }),
                            dataIndex: "name",
                        },
                    };
                    return (value === null || value === void 0 ? void 0 : value.name) ? (_jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0)) : ("-");
                },
            },
            {
                id: "company",
                title: t("management.transactions.fields.company"),
                key: "management.transactions.fields.company",
                dataIndex: ["company"],
                sorter: true,
                render: (value, model) => {
                    const props = {
                        type: "relation",
                        value,
                        relation: {
                            path: router.path(Routes.COMPANIES_VIEW, {
                                params: {
                                    id: value === null || value === void 0 ? void 0 : value._id,
                                },
                            }),
                            dataIndex: "name",
                        },
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "amount",
                title: t("management.transactions.fields.amount"),
                key: "management.transactions.fields.amount",
                dataIndex: ["amount"],
                sorter: true,
                render: (value, model) => {
                    var _a, _b, _c;
                    const props = {
                        type: "number",
                        value: `${(value !== null && value !== void 0 ? value : 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })} ${(_b = (_a = model === null || model === void 0 ? void 0 : model.sourceBankAccount) === null || _a === void 0 ? void 0 : _a.currency) !== null && _b !== void 0 ? _b : (_c = model === null || model === void 0 ? void 0 : model.destinationBankAccount) === null || _c === void 0 ? void 0 : _c.currency}`,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "notes",
                title: t("management.transactions.fields.notes"),
                key: "management.transactions.fields.notes",
                dataIndex: ["notes"],
                sorter: true,
                render: (value, model) => {
                    const props = {
                        type: "string",
                        value,
                    };
                    return _jsx(UIComponents.AdminListItemRenderer, Object.assign({}, props), void 0);
                },
            },
            {
                id: "approval",
                title: t("management.transactions.fields.approval"),
                key: "management.transactions.fields.approval",
                dataIndex: ["approval"],
                sorter: true,
                render: (_, model) => {
                    var _a;
                    return model.type === TransactionType.expense ? (_jsx(TransactionApprovalButton, { approved: (_a = model === null || model === void 0 ? void 0 : model.approval) === null || _a === void 0 ? void 0 : _a.status, transactionId: model._id }, void 0)) : ("-");
                },
            },
            // {
            //   id: "sourceBankAccount",
            //   title: t("management.transactions.fields.sourceBankAccount"),
            //   key: "management.transactions.fields.sourceBankAccount",
            //   dataIndex: ["sourceBankAccount"],
            //   sorter: true,
            //   width: 350,
            //   render: (value, model) => {
            //     const dataValue = {
            //       value: `${value?.accountNumber ?? "N/A"}`,
            //     };
            //     const props = {
            //       type: "relation",
            //       value: dataValue,
            //       relation: {
            //         path: router.path(Routes.BANK_ACCOUNTS_VIEW, {
            //           params: {
            //             id: value?._id,
            //           },
            //         }),
            //         dataIndex: "value",
            //       },
            //     };
            //     return <UIComponents.AdminListItemRenderer {...props} />;
            //   },
            // },
            // {
            //   id: "destinationBankAccount",
            //   title: t("management.transactions.fields.destinationBankAccount"),
            //   key: "management.transactions.fields.destinationBankAccount",
            //   dataIndex: ["destinationBankAccount"],
            //   sorter: true,
            //   width: 350,
            //   render: (value, model) => {
            //     const dataValue = {
            //       value: `${value?.accountNumber ?? "N/A"}`,
            //     };
            //     const props = {
            //       type: "relation",
            //       value: dataValue,
            //       relation: {
            //         path: router.path(Routes.BANK_ACCOUNTS_VIEW, {
            //           params: {
            //             id: value?._id,
            //           },
            //         }),
            //         dataIndex: "value",
            //       },
            //     };
            //     return <UIComponents.AdminListItemRenderer {...props} />;
            //   },
            // },
            // {
            //   id: "completeDate",
            //   title: t("management.transactions.fields.completeDate"),
            //   key: "management.transactions.fields.completeDate",
            //   dataIndex: ["completeDate"],
            //   sorter: true,
            //   render: (value, model) => {
            //     const props = {
            //       type: "date",
            //       value,
            //     };
            //     return <UIComponents.AdminListItemRenderer {...props} />;
            //   },
            // },
            // {
            //   id: "transactionDate",
            //   title: t("management.transactions.fields.transactionDate"),
            //   key: "management.transactions.fields.transactionDate",
            //   dataIndex: ["transactionDate"],
            //   sorter: true,
            //   render: (value, model) => {
            //     const props = {
            //       type: "date",
            //       value,
            //     };
            //     return <UIComponents.AdminListItemRenderer {...props} />;
            //   },
            // },
            // {
            //   id: "transactionFiles",
            //   title: t("management.transactions.fields.transactionFiles"),
            //   key: "management.transactions.fields.transactionFiles",
            //   dataIndex: ["transactionFiles"],
            //   sorter: true,
            //   render: (values, model) => {
            //     return (
            //       <>
            //         {values && (
            //           <div className="transaction-list-download-file-container">
            //             {values.map((value: any, idx: number) => {
            //               return (
            //                 <a href={value.downloadUrl} target="_blank" key={idx}>
            //                   {value.name}
            //                 </a>
            //               );
            //             })}
            //           </div>
            //         )}
            //       </>
            //     );
            //   },
            // },
            // {
            //   id: "createdAt",
            //   title: t("management.transactions.fields.createdAt"),
            //   key: "management.transactions.fields.createdAt",
            //   dataIndex: ["createdAt"],
            //   sorter: true,
            //   render: (value, model) => {
            //     const props = {
            //       type: "date",
            //       value,
            //     };
            //     return <UIComponents.AdminListItemRenderer {...props} />;
            //   },
            // },
            // {
            //   id: "updatedAt",
            //   title: t("management.transactions.fields.updatedAt"),
            //   key: "management.transactions.fields.updatedAt",
            //   dataIndex: ["updatedAt"],
            //   sorter: true,
            //   render: (value, model) => {
            //     const props = {
            //       type: "date",
            //       value,
            //     };
            //     return <UIComponents.AdminListItemRenderer {...props} />;
            //   },
            // },
            // {
            //   id: "createdBy",
            //   title: t("management.transactions.fields.createdBy"),
            //   key: "management.transactions.fields.createdBy",
            //   dataIndex: ["createdBy"],
            //   sorter: true,
            //   render: (value, model) => {
            //     const props = {
            //       type: "relation",
            //       value,
            //       relation: {
            //         path: router.path(Routes.USERS_VIEW, {
            //           params: {
            //             id: value?._id,
            //           },
            //         }),
            //         dataIndex: "fullName",
            //       },
            //     };
            //     return <UIComponents.AdminListItemRenderer {...props} />;
            //   },
            // },
            // {
            //   id: "updatedBy",
            //   title: t("management.transactions.fields.updatedBy"),
            //   key: "management.transactions.fields.updatedBy",
            //   dataIndex: ["updatedBy"],
            //   sorter: true,
            //   render: (value, model) => {
            //     const props = {
            //       type: "relation",
            //       value,
            //       relation: {
            //         path: router.path(Routes.USERS_VIEW, {
            //           params: {
            //             id: value?._id,
            //           },
            //         }),
            //         dataIndex: "fullName",
            //       },
            //     };
            //     return <UIComponents.AdminListItemRenderer {...props} />;
            //   },
            // },
            // {
            //   id: "transactionIdentifier",
            //   title: t("management.transactions.fields.transactionIdentifier"),
            //   key: "management.transactions.fields.transactionIdentifier",
            //   dataIndex: ["transactionIdentifier"],
            //   sorter: true,
            //   render: (value, model) => {
            //     const props = {
            //       type: "string",
            //       value,
            //     };
            //     return <UIComponents.AdminListItemRenderer {...props} />;
            //   },
            // },
        ]);
    }
    static getSortMap() {
        return {
            createdBy: "createdBy.fullName",
            updatedBy: "updatedBy.fullName",
            company: "company._id",
            external: "external._id",
            sourceBankAccount: "sourceBankAccount._id",
            destinationBankAccount: "destinationBankAccount._id",
            transactionFiles: "transactionFiles._id",
        };
    }
    static getRequestBody() {
        return {
            _id: 1,
            type: 1,
            createdAt: 1,
            updatedAt: 1,
            transactionDate: 1,
            transactionIdentifier: 1,
            dueDate: 1,
            amount: 1,
            isCompleted: 1,
            completeDate: 1,
            notes: 1,
            approval: {
                status: 1,
            },
            createdBy: {
                _id: 1,
                fullName: 1,
            },
            createdById: 1,
            updatedBy: {
                _id: 1,
                fullName: 1,
            },
            updatedById: 1,
            company: {
                _id: 1,
                name: 1,
            },
            companyId: 1,
            external: {
                _id: 1,
                name: 1,
            },
            externalId: 1,
            sourceBankAccount: {
                _id: 1,
                accountNumber: 1,
                currency: 1,
            },
            sourceBankAccountId: 1,
            destinationBankAccount: {
                _id: 1,
                accountNumber: 1,
                currency: 1,
            },
            destinationBankAccountId: 1,
            transactionFiles: {
                _id: 1,
                downloadUrl: 1,
                name: 1,
            },
            transactionFilesIds: 1,
        };
    }
};
PaymentToApproveTransactionList = __decorate([
    Service({ transient: true })
], PaymentToApproveTransactionList);
export { PaymentToApproveTransactionList };
